var React = require('react');

function BgMoon2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M105.155 209.56C104.478 211.514 103.705 213.746 102.749 215.603C148.694 224.648 195.521 198.676 211.285 153.187C228.596 103.232 202.054 49.0212 152.374 31.8053C104.928 15.3632 53.4645 38.4782 33.6855 83.8264C37.7863 84.6223 41.7904 85.6973 45.6977 87.0514C95.7527 104.085 122.563 159.327 105.155 209.56Z","fill":"#EB5A30"}));
}

BgMoon2.defaultProps = {"width":"243","height":"243","viewBox":"0 0 243 243","fill":"none"};

module.exports = BgMoon2;

BgMoon2.default = BgMoon2;
